import clsx from "clsx";
import React from "react";
import "./analyticsCardHeader.scss";

interface IAnalyticsCardHeaderProps extends React.ComponentPropsWithoutRef<"div"> { }

export const AnalyticsCardHeader = (props: IAnalyticsCardHeaderProps) => {
    return <div {...props} className={clsx("analytics-card-header", props.className)} />;
};
